import { render, staticRenderFns } from "./IconComments.vue?vue&type=template&id=1663f861&scoped=true&"
import script from "./IconComments.vue?vue&type=script&lang=js&"
export * from "./IconComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1663f861",
  null
  
)

export default component.exports